import { useCallback, useRef, useState } from 'react';

/**
 * Mede a altura real de um elemento (a barra do composer) e fica de olho
 * quando ela muda de tamanho — o textarea cresce, a mensagem de limite
 * aparece, a área segura do iPhone entra. Usa ResizeObserver.
 *
 * Devolve um ref de callback (some quando o elemento sai da tela e volta a
 * medir quando ele reaparece) e a altura em pixels.
 */
export function useAlturaElemento() {
  const [altura, setAltura] = useState(0);
  const obsRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback((el: HTMLElement | null) => {
    obsRef.current?.disconnect();
    obsRef.current = null;

    if (!el) {
      setAltura(0);
      return;
    }

    const medir = () => setAltura(el.getBoundingClientRect().height);
    medir();

    if (typeof ResizeObserver !== 'undefined') {
      const obs = new ResizeObserver(medir);
      obs.observe(el);
      obsRef.current = obs;
    }

    return () => {
      obsRef.current?.disconnect();
      obsRef.current = null;
    };
  }, []);

  return { ref, altura };
}